import React from 'react';
import { AntdSkeleton } from '@ui/components';

export const QuestionsSkeleton = () => {
  return (
    <ul
      style={{ borderBottomStyle: 'solid' }}
      className="list-none m-0 p-0 mt-3 border-b border-base-300"
    >
      <li
        style={{ borderTopStyle: 'solid' }}
        className="py-2 flex items-center justify-between border-t-[1px] border-base-300"
      >
        <AntdSkeleton.Input className="w-full" />
      </li>
      <li
        style={{ borderTopStyle: 'solid' }}
        className="py-2 flex items-center justify-between border-t-[1px] border-base-300"
      >
        <AntdSkeleton.Input className="w-full" />
      </li>
      <li
        style={{ borderTopStyle: 'solid' }}
        className="py-2 flex items-center justify-between border-t-[1px] border-base-300"
      >
        <AntdSkeleton.Input className="w-full" />
      </li>
    </ul>
  );
};
